<template>
    <form @submit.prevent="submitNoteAndComment">
      <label for="note">Rate the Offer: </label>
      <input type="number" id="note" v-model="note" min="1" max="5" required />
      
      <label for="comment">Leave a Comment: </label>
      <textarea id="comment" v-model="comment"></textarea>
      
      <button type="submit">Submit</button>
      <p>{{ message }}</p>
    </form>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    props: {
      purchaseId: {
        type: String,
        required: true
      }
    },
    setup(props) {
      const store = useStore();
      const note = ref(5);
      const comment = ref('');
      const message = ref('');
  
      const submitNoteAndComment = async () => {
        const userId = store.state.user.id;
        const response = await store.dispatch('offers/submitNoteAndComment', {
          userId,
          purchaseId: props.purchaseId,
          note: note.value,
          comment: comment.value
        });
        message.value = response.message;
      };
  
      return { note, comment, submitNoteAndComment, message };
    }
  }
  </script>

<style>
/* ==================== NATIVE APP STYLES ==================== */
body.is-native form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 16px calc(24px + env(safe-area-inset-bottom)) 16px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

body.is-native form label {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  display: block;
  margin-bottom: -4px;
}

body.is-native form input[type="number"] {
  width: 100%;
  box-sizing: border-box;
  font-size: 16px !important;
  height: 48px;
  padding: 12px 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
}

body.is-native form textarea {
  width: 100%;
  box-sizing: border-box;
  font-size: 16px !important;
  min-height: 120px;
  padding: 12px 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  resize: vertical;
  font-family: inherit;
}

body.is-native form input:focus,
body.is-native form textarea:focus {
  border-color: #dd4124;
}

body.is-native form button[type="submit"] {
  width: 100%;
  height: 48px;
  background: #dd4124;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
</style>
